import React from "react";
import SEO from "../components/SEO";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white text-gray-800">
      <SEO
        title="Privacy Policy | 100Eyes Technologies LLP"
        description="Read 100Eyes Technologies' Privacy Policy to learn how we protect, use, and manage your data with full transparency."
        canonical="https://100eyestechnologies.com/privacy-policy"
      />

      <div className="max-w-5xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold text-blue-700 mb-6">Privacy Policy</h1>
        <p className="mb-4 text-sm text-gray-500">
          Effective Date: {new Date().toLocaleDateString()}
        </p>

        <p className="mb-6">
          At <strong>100Eyes Technologies LLP</strong>, we value your trust and are fully committed to
          protecting your personal information. This Privacy Policy describes how we collect, use, and safeguard
          data obtained through our website and services.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">1. Information We Collect</h2>
        <p className="mb-4">
          We may collect information such as your name, email address, phone number, company details, project
          information, and technical details like IP address or browser type.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">2. How We Use Your Information</h2>
        <ul className="list-disc ml-6 mb-4">
          <li>To provide and manage services you request.</li>
          <li>For internal performance analysis and service improvement.</li>
          <li>To ensure transparency in communication and operations.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">3. Data Sharing Policy</h2>
        <p className="mb-4">
          We <strong>do not share, sell, or rent</strong> any customer data with any third party, affiliate, or
          sister company. Data is used strictly for internal purposes such as analytics or legal compliance if
          required by law.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">4. Data Security</h2>
        <p className="mb-4">
          We implement strong security measures, including encryption and secure servers, to ensure your data
          remains protected at all times.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">5. Data Retention</h2>
        <p className="mb-4">
          We retain data only as long as necessary to fulfill the purpose for which it was collected or as
          required by law.
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">6. Your Rights</h2>
        <p className="mb-4">
          You can request access, correction, or deletion of your personal information by contacting us at{" "}
          <a href="mailto:info@100eyestechnologies.com" className="text-blue-600 underline">
            info@100eyestechnologies.com
          </a>
          .
        </p>

        <h2 className="text-2xl font-semibold text-blue-600 mt-8 mb-3">7. Updates</h2>
        <p>
          We may update this Privacy Policy periodically. Any changes will be reflected on this page with a new
          effective date.
        </p>
      </div>
    </div>
  );
}
